<!-- Modern Header with Glassmorphism Design -->
<header class="modern-header position-fixed w-100" style="top: 0; z-index: 1050;">
  <nav class="navbar navbar-expand-lg py-3">
    <div class="container">
      <!-- Logo and Brand -->
      <a class="navbar-brand d-flex align-items-center" href="#" style="text-decoration: none;">
        <img src="../../../../assets/img/logo_2.png" alt="RoutiGo Logo" class="logo-img me-3">
        <!-- <span class="brand-text fw-bold">RoutiGo</span> -->
      </a>
      
      <!-- Mobile Menu Toggle -->
      <button class="navbar-toggler border-0" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      
      <!-- Navigation Menu -->
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto align-items-center">
          <li class="nav-item">
            <a class="nav-link fw-medium" href="#" style="cursor: pointer;">Inicio</a>
          </li>
          <li class="nav-item">
            <a class="nav-link fw-medium" (click)="onTuEligesClick($event)" style="cursor: pointer;">Tu eliges</a>
          </li>
          <li class="nav-item">
            <a class="nav-link fw-medium" (click)="onComoFuncionaClick($event)" style="cursor: pointer;">Cómo Funciona</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<!-- Main Content with Modern Layout -->
<main class="flex-grow-1" style="margin-top: 90px;">
  <router-outlet />
</main>

<!-- Modern Footer with Glassmorphism Design -->
<footer class="mt-auto position-relative overflow-hidden" style="background: linear-gradient(135deg, var(--dark-color) 0%, #1a2332 50%, var(--dark-color) 100%); color: #fff; padding: 60px 0 40px 0;">
  <!-- Decorative Background Elements -->
  <div class="position-absolute w-100 h-100" style="top: 0; left: 0; z-index: 1;">
    <div style="position: absolute; top: -50px; left: -100px; width: 200px; height: 200px; background: radial-gradient(circle, rgba(82, 220, 183, 0.1) 0%, transparent 70%); border-radius: 50%;"></div>
    <div style="position: absolute; bottom: -50px; right: -80px; width: 150px; height: 150px; background: radial-gradient(circle, rgba(163, 223, 255, 0.1) 0%, transparent 70%); border-radius: 50%;"></div>
  </div>
  
  <div class="container position-relative" style="z-index: 2;">
    <div class="row g-4 align-items-start">
      <!-- Logo and Brand Section -->
      <div class="col-lg-4 col-md-12 text-center text-lg-start">
        <div class="mb-3">
          <h3 class="fw-bold mb-2" style="color: var(--primary-color); font-size: 1.8rem;">
            RoutiGo
          </h3>
          <p class="mb-3" style="color: rgba(255, 255, 255, 0.8); font-size: 1rem; line-height: 1.6;">
            Revolucionando la movilidad urbana a través del carpool inteligente y seguro.
          </p>
          
          <!-- Social Media Links -->
          <div class="d-flex justify-content-center justify-content-lg-start gap-3">
            <a href="https://www.facebook.com/routigoapp" target="_blank" class="text-decoration-none d-inline-flex align-items-center justify-content-center rounded-circle" 
               style="width: 45px; height: 45px; background: rgba(82, 220, 183, 0.1); backdrop-filter: blur(10px); border: 1px solid rgba(82, 220, 183, 0.2); color: var(--primary-color); transition: all 0.3s ease;">
              <i class="bi bi-facebook" style="font-size: 1.2rem;"></i>
            </a>
            <a href="https://www.instagram.com/routigoapp" target="_blank" class="text-decoration-none d-inline-flex align-items-center justify-content-center rounded-circle" 
               style="width: 45px; height: 45px; background: rgba(82, 220, 183, 0.1); backdrop-filter: blur(10px); border: 1px solid rgba(82, 220, 183, 0.2); color: var(--primary-color); transition: all 0.3s ease;">
              <i class="bi bi-instagram" style="font-size: 1.2rem;"></i>
            </a>
          </div>
        </div>
      </div>

      <!-- Enlaces Rápidos -->
      <div class="col-lg-4 col-md-6 text-center text-md-start">
        <h5 class="fw-bold mb-4" style="color: var(--secondary-color);">Enlaces Rápidos</h5>
        <ul class="list-unstyled">
          
          <li class="mb-2">
            <a routerLink="/public/terms-and-conditions" class="text-decoration-none d-inline-flex align-items-center" 
               style="color: rgba(255, 255, 255, 0.8); transition: all 0.3s ease; font-size: 0.95rem;">
              <i class="fas fa-chevron-right me-2" style="font-size: 0.8rem; color: var(--primary-color);"></i>
              Términos y Condiciones
            </a>
          </li>
          <li class="mb-2">
            <a routerLink="/public/privacy-policy" class="text-decoration-none d-inline-flex align-items-center" 
               style="color: rgba(255, 255, 255, 0.8); transition: all 0.3s ease; font-size: 0.95rem;">
              <i class="fas fa-chevron-right me-2" style="font-size: 0.8rem; color: var(--primary-color);"></i>
              Política de Privacidad
            </a>
          </li>
          <li class="mb-2">
            <a routerLink="/public/data-deletion" class="text-decoration-none d-inline-flex align-items-center" 
               style="color: rgba(255, 255, 255, 0.8); transition: all 0.3s ease; font-size: 0.95rem;">
              <i class="fas fa-chevron-right me-2" style="font-size: 0.8rem; color: var(--primary-color);"></i>
              Solicitud de Eliminación de Datos
            </a>
          </li>
        </ul>
      </div>
      
      <!-- Download App -->
      <div class="col-lg-4 col-md-6 text-center text-md-start text-lg-end">
        <h5 class="fw-bold mb-4" style="color: var(--secondary-color);">Descarga la App</h5>
        <div class="d-flex flex-column gap-3">
          <a href="https://play.google.com/store/apps/details?id=co.com.routigo.app" target="_blank" class="text-decoration-none">
            <img src="../../../../assets/img/play_store_placeholder.png" alt="Google Play" 
                 style="height: 45px; width: auto; border-radius: 8px; transition: transform 0.3s ease;">
          </a>
          <a href=" https://apps.apple.com/co/app/routigo/id6755113975" target="_blank" class="text-decoration-none">
            <img src="../../../../assets/img/app_store_placeholder.png" alt="App Store" 
                 style="height: 45px; width: auto; border-radius: 8px; transition: transform 0.3s ease;">
          </a>
        </div>
      </div>
    </div>
    
    <!-- Divider -->
    <hr class="my-4" style="border-color: rgba(82, 220, 183, 0.2); opacity: 0.5;">
    
    <!-- Bottom Section -->
    <div class="row align-items-center">
      <div class="col-md-6 text-center text-md-start">
        <p class="mb-0" style="color: rgba(255, 255, 255, 0.7); font-size: 0.9rem;">
          © 2026 <span style="color: var(--primary-color); font-weight: 600;">RoutiGo</span>. Todos los derechos reservados.
        </p>
      </div>
      <div class="col-md-6 text-center text-md-end">
        <p class="mb-0" style="color: rgba(255, 255, 255, 0.7); font-size: 0.9rem;">
          Hecho con ❤️ para una movilidad más inteligente
        </p>
      </div>
    </div>
  </div>
</footer>

<!-- Footer Styles -->
<style>
footer a:hover {
  transform: scale(1.1);
  color: var(--primary-color) !important;
}

footer .rounded-circle:hover {
  background: rgba(82, 220, 183, 0.2) !important;
  border-color: var(--primary-color) !important;
  transform: scale(1.1) translateY(-2px);
  box-shadow: 0 8px 25px rgba(82, 220, 183, 0.3);
}

footer img:hover {
  transform: scale(1.05);
}

/* Add Font Awesome if not already included */
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css');

/* Ensure main layout is flexible */
body {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

main {
  flex: 1;
}
</style>
